export function releaseVideo(video: HTMLVideoElement): void {
  video.pause();
  video.removeAttribute('src');
  video.load();
}

/** A preloader owns its decoder only until completion or cancellation. */
export function preloadMedia(url: string, type: 'image' | 'video', signal: AbortSignal): Promise<void> {
  if (signal.aborted) return Promise.resolve();
  return new Promise((resolve) => {
    const media = type === 'video' ? document.createElement('video') : new Image();
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      media.onload = null;
      media.onerror = null;
      signal.removeEventListener('abort', finish);
      if (media instanceof HTMLVideoElement) {
        media.onloadedmetadata = null;
        releaseVideo(media); // Release the metadata preloader's media pipeline/decoder.
      } else {
        media.removeAttribute('src');
      }
      resolve();
    };
    media.onerror = finish;
    signal.addEventListener('abort', finish, { once: true });
    if (media instanceof HTMLVideoElement) {
      media.preload = 'metadata';
      media.onloadedmetadata = finish;
    } else {
      media.decoding = 'async';
      media.onload = finish;
    }
    media.src = url;
  });
}
